import { gql } from "@apollo/client"

const GET_PREVIEW_EVENT_CANCELLED_EMAIL = gql`
  query($input: PreviewEventCancelledEmailInput!) {
    previewEventCancelledEmail(input: $input) {
      html
      text
    }
  }
`

export { GET_PREVIEW_EVENT_CANCELLED_EMAIL }
